import { createContext, useEffect, useState } from 'react'

export const UIContext = createContext()

export const UIProvider = ({ children }) => {
	const [Theme, setTheme] = useState(
		window.localStorage.getItem('Theme')
			? window.localStorage.getItem('Theme')
			: 0,
	)

	const size = '25px'
	let fontColor = '#000'
	let bgColor = '#fff'
	let selectedValue = '#2684FF'
	if (Theme === '1') selectedValue = '#bec080'
	if (Theme === '2') {
		// bgColor = '#535353ff'
		// fontColor = '#e0e0e0'
		selectedValue = '#333'
	}
	const customStyles = {
		control: (provided, state) => ({
			...provided,
			background: bgColor,
			borderColor: '#9e9e9e',
			minHeight: size,
			height: size,
			boxShadow: state.isFocused ? null : null,
		}),

		valueContainer: (provided, state) => ({
			...provided,
			height: size,
			padding: '0 6px',
		}),

		input: (provided, state) => ({
			...provided,
			margin: '0px',
		}),
		indicatorSeparator: (state) => ({
			display: 'none',
		}),
		indicatorsContainer: (provided, state) => ({
			...provided,
			height: size,
		}),
		singleValue: (provided, state) => ({
			...provided,
			color: fontColor,
		}),
		option: (provided, state) => ({
			...provided,
			color: state.isSelected
				? '#fff' // texte quand l'option est sélectionnée
				: state.isFocused
					? '#000' // texte quand survol/focus
					: '#333', // texte normal
			backgroundColor: state.isSelected
				? selectedValue
				: state.isFocused
					? '#eee'
					: null,
		}),
		menuPortal: (base) => ({ ...base, zIndex: 9999 }),
		// menu: () => ({
		// 	// position: 'fixed',
		// 	// width: '50%',
		// 	// right: 10,
		// 	width: '50%',
		// 	right: 40,
		// }),
		menuPosition: 'fixed',
	}
	//for disabled selects
	const customStylesDisabled = {
		control: (provided, state) => ({
			...provided,
			// background: bgColor,
			// borderColor: '#9e9e9e',
			minHeight: size,
			height: size,
			boxShadow: state.isFocused ? null : null,
		}),

		valueContainer: (provided, state) => ({
			...provided,
			height: size,
			padding: '0 6px',
		}),

		input: (provided, state) => ({
			...provided,
			margin: '0px',
		}),
		indicatorSeparator: (state) => ({
			display: 'none',
		}),
		indicatorsContainer: (provided, state) => ({
			...provided,
			height: size,
		}),
		singleValue: (provided, state) => ({
			...provided,
			// color: fontColor,
		}),
		option: (provided, state) => ({
			...provided,
			color: state.isSelected
				? '#fff' // texte quand l'option est sélectionnée
				: state.isFocused
					? '#000' // texte quand survol/focus
					: '#333', // texte normal
			backgroundColor: state.isSelected
				? selectedValue
				: state.isFocused
					? '#eee'
					: null,
		}),
		// menu: () => ({
		// 	// position: 'fixed',
		// 	// width: '50%',
		// 	// right: 10,
		// 	width: '50%',
		// 	right: 40,
		// }),
		menuPosition: 'fixed',
	}
	const searchOption = (options, searchedValue, defaultValue, label) => {
		if (options.length > 0) {
			let statValue = defaultValue
			if (options.find((opt) => opt.value === searchedValue))
				statValue = searchedValue
			// else statValue = 99
			let newopt = options.find((opt) => opt.value === statValue)

			if (newopt) return newopt
			else {
				console.log(label + ' not found')
				return [
					{
						value: Number(statValue),
						label: Number(statValue),
						key: label + Number(statValue),
					},
				]
			}
		}
		return null
	}

	useEffect(() => {
		try {
			window.localStorage.setItem('Theme', Theme)
		} catch (error) {
			console.error('failed to save theme', error)
		}
	}, [Theme])

	return (
		<UIContext.Provider
			value={{
				Theme,
				setTheme,
				customStyles,
				customStylesDisabled,
				searchOption,
			}}
		>
			{children}
		</UIContext.Provider>
	)
}
